import type { InjectionKey } from 'vue'
import type { MasqueradeTarget } from '@/api/auth'

// The authenticated layout owns password confirmation and account switching.
export const openMasqueradeTargetKey: InjectionKey<(target: MasqueradeTarget) => void> = Symbol('openMasqueradeTarget')
